import { render, staticRenderFns } from "./facebookText.vue?vue&type=template&id=e495ce70&scoped=true"
import script from "./facebookText.vue?vue&type=script&lang=js"
export * from "./facebookText.vue?vue&type=script&lang=js"
import style0 from "./facebookText.vue?vue&type=style&index=0&id=e495ce70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e495ce70",
  null
  
)

export default component.exports